(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pwt24-geobubble-measure"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pwt24-geobubble-measure')) {
    customElements.define(
      'pwt24-geobubble-measure',
      class extends HTMLElement {
        connectedCallback() {
          this.form = this.closest('form');
          this.lengthInput = this.querySelector('[data-pwt24-length]');
          this.widthInput = this.querySelector('[data-pwt24-width]');
          this.areaOutput = this.querySelector('[data-pwt24-area]');
          this.totalOutput = this.querySelector('[data-pwt24-total]');
          this.areaProperty = this.querySelector('[data-pwt24-area-property]');
          this.quantityInput = this.form?.querySelector('[data-pwt24-billing-quantity]');
          this.unitPrice = Number(this.dataset.unitPrice || 0) / 100;
          this.formatter = new Intl.NumberFormat(this.dataset.locale || 'de-DE', {
            style: 'currency',
            currency: this.dataset.currency || 'EUR',
          });
          this.addEventListener('input', () => this.update());
          this.form?.addEventListener('submit', () => this.update());
          this.update();
        }

        update() {
          const length = Number(this.lengthInput?.value || 0);
          const width = Number(this.widthInput?.value || 0);
          if (length <= 0 || width <= 0) {
            this.areaOutput.textContent = '–';
            this.totalOutput.textContent = '–';
            this.areaProperty.value = '';
            this.quantityInput.value = '1';
            return;
          }

          const exactArea = (length * width) / 10000;
          let billingArea;
          if (this.dataset.pricingMode === 'liderpool_safety') {
            if (exactArea < 10) {
              billingArea = Math.ceil(exactArea * 1.5);
            } else if (exactArea < 16) {
              billingArea = Math.ceil(exactArea * 1.25);
            } else if (exactArea < 20) {
              billingArea = 20;
            } else {
              billingArea = Math.ceil(exactArea);
            }
          } else {
            billingArea = Math.max(1, Math.ceil(exactArea));
          }
          this.areaOutput.textContent = `${exactArea.toLocaleString(this.dataset.locale || 'de-DE', { maximumFractionDigits: 2 })} m² (${billingArea} m²)`;
          this.totalOutput.textContent = this.formatter.format(billingArea * this.unitPrice);
          this.areaProperty.value = `${billingArea} m² (berechnet aus ${length} × ${width} cm)`;
          this.quantityInput.value = String(billingArea);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
